import { forwardRef, type CSSProperties } from 'react';

import { SIZE, SCROLL_CONST } from './Scrollbar.enums';
import { useScrollbar } from './Scrollbar.hooks';
import { Scrollbar, scrollPosition, scrollSize } from './Scrollbar.styles';

import type { ScrollbarProps } from './Scrollbar.d';

const ScrollbarBase = forwardRef(
  ({ color, onScroll, scrollWidth, size = SIZE.SMALL }: any, ref: ScrollbarProps['ref']) => {
    const { barPosition, handleBarRef } = useScrollbar({ scrollRef: ref, onScroll });

    return (
      <Scrollbar.Component ref={handleBarRef} data-size={size} data-testid={SCROLL_CONST.TEST_ID}>
        <Scrollbar.Scroll
          data-color={color}
          data-size={!!scrollWidth}
          style={
            {
              [scrollPosition]: `${barPosition}`,
              [scrollSize]: `${scrollWidth}`,
            } as CSSProperties
          }
        />
      </Scrollbar.Component>
    );
  },
);

ScrollbarBase.displayName = 'ScrollbarBase';

export default ScrollbarBase;
